"use client";

/**
 * Chrome WebMCP focus styles. Kept out of globals.css because LightningCSS /
 * PostCSS reject unknown pseudo-classes like :tool-form-active.
 * @see https://developer.chrome.com/docs/ai/webmcp/declarative-api
 */
export function WebmcpFocusStyles() {
  return (
    <style
      // eslint-disable-next-line react/no-danger -- static CSS for agent focus
      dangerouslySetInnerHTML={{
        __html: `
form:tool-form-active {
  outline: 2px dashed color-mix(in srgb, var(--color-text-accent, #e51a4c) 70%, transparent);
  outline-offset: 4px;
  border-radius: var(--radius-element, 8px);
}
button:tool-submit-active,
input:tool-submit-active {
  outline: 2px dashed var(--color-text-accent, #e51a4c);
  outline-offset: 2px;
}
`.trim(),
      }}
    />
  );
}
